import React from "react";
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { GetApi } from "../../../api/api";
import { ClassificationHeader } from "../../../api/types";
import { Feedback } from "../../../components/Validator";
import AppContext from '../../../components/AppContext';
import withModal, { WithModalProps, InjectedProps } from "../../../components/HOC/WithModal";
import Pending from '../../../components/Pending';


const nameId = 'nameInputClassification';
const descriptionId = 'descriptionInputClassification';

interface InnerEditProps extends EditProps {
  classification: ClassificationHeader
  languages: Array<{ label: string, value: string }>
}

interface InnerEditState {
  classification: ClassificationHeader
  languages: Array<{ label: string, value: string }>
  valid: Feedback
  disabled: boolean
}

class InnerEdit extends React.Component<InnerEditProps, InnerEditState> {
  public static contextType = AppContext;

  constructor(props: InnerEditProps) {
    super(props);
    this.state = {
      classification: props.classification,
      languages: props.languages,
      valid: props.valid,
      disabled: props.disabled
    }
  }

  public render() {
    const disabledName = this.state.disabled || (!this.state.valid.valid && this.state.valid.id !== nameId)
    const disabledDescription = this.state.disabled || (!this.state.valid.valid && this.state.valid.id !== descriptionId)
    
    const inValidName = this.state.valid.id === nameId;
    const inValidDescription = this.state.valid.id === descriptionId;

    return (
      <Form>
        <Form.Group as={Row} controlId={nameId}>
          <Form.Label column={true} md='3'>
            Name{' '}<span className="text-danger">*</span>
          </Form.Label>
          <Col md='9'>
            <Form.Control
              type='text'
              value={this.state.classification.name}
              onChange={this.setName}
              onBlur={this.updateClassification}
              disabled={disabledName}
              isInvalid={inValidName}
            />
            <Form.Control.Feedback type='invalid'>
              {this.state.valid.message}
            </Form.Control.Feedback>
            <Form.Text>
              Name of the classification.
            </Form.Text>
          </Col>
        </Form.Group>
        
        <Form.Group as={Row} controlId={descriptionId}>
          <Form.Label column={true} md='3'>Description</Form.Label>
          <Col md='9'>
            <Form.Control
              type='text'
              value={this.state.classification.description}
              onChange={this.setDescription}
              onBlur={this.updateClassification}
              disabled={disabledDescription}
              isInvalid={inValidDescription}
            />
            <Form.Control.Feedback type='invalid'>
              {this.state.valid.message}
            </Form.Control.Feedback>
            <Form.Text>
              An optional description for the classification.
            </Form.Text>
          </Col>
        </Form.Group>
      </Form>
    )
  }

  private updateClassification = () => {
    if (this.state.valid.valid) {
      this.setDisabled(true);
      GetApi()
      .then(api => api.updateClassification(
        this.props.ccId,
        // this.state.classification
      ))
      .catch(error => this.context.useToasts.addToast(error, 'danger'))
      .finally(() => this.setDisabled(false))
    }
  }

  private setName = ( e: any ) => {
    e.persist();
    // const isValid = ClassificationValidator.getFieldValidator('name')(nameId, e.target.value)
    const isValid = { valid: true }
    this.setState(prevState => ({
      classification: {
        ...prevState.classification,
        name: e.target.value
      },
      valid: isValid
    }), () => this.props.setValid(isValid))
  }

  private setDescription = ( e: any ) => {
    e.persist();
    // const isValid = ClassificationValidator.getFieldValidator('description')(descriptionId, e.target.value)
    const isValid = { valid: true }
    this.setState(prevState => ({
      classification: {
        ...prevState.classification,
        description: e.target.value
      },
      valid: isValid
    }), () => this.props.setValid(isValid))
  }

  // private validate() {
  //   return this.state.structureKey.length > 0
  //   && this.state.structureId
  //     && (this.state.languageValue
  //       && this.props.languages.find(l => l.value === this.state.languageValue))
  // }

  private setDisabled = ( value: boolean ) => {
    this.props.setDisabled(value);
    this.setState({
      disabled: value
    });
  }
}

interface EditProps extends InjectedProps {
  ccId: string
}

const Edit = ( props: EditProps ) => {
  const getData = async (): Promise<InnerEditProps> => {
    const api = await GetApi();
    const classification = await api.getClassification(props.ccId);
    return {
      ...props,
      classification: {
        ...classification,
        name: classification.name || '',
        description: classification.description || ''
      },
      languages: [
        {
          label: "English",
          value: "en"
        },
        {
          label: "Swedish",
          value: "sv"
        }
      ]
    }
  }

  const renderSuccess = ( innerProps: InnerEditProps ) => <InnerEdit {...innerProps} />;

  return (
    <Pending
      getData={getData}
      renderSuccess={renderSuccess}
    />
  );
}

export interface EditModalProps extends WithModalProps {
  ccId: string
}

const EditModal = withModal(Edit);

export default EditModal;
